import { tv } from "tailwind-variants";

export const UIBackToTop = tv({
    slots: {
        base: [
            "tw:fixed tw:right-2 tw:layer-overlay/[0] tw:md:right-8 tw:bottom-2 tw:md:bottom-8",
            "tw:transition-opacity tw:transition-visibility tw:ease-in-out"
        ]
    },
    variants: {
        visible: {
            true: {
                base: "tw:opacity-100 tw:visible tw:duration-[0s,200ms]"
            },
            false: {
                base: "tw:opacity-0 tw:invisible tw:duration-[200ms,0s]"
            }
        }
    }
});
